export enum FreightBookingAccordionStepsActionTypes {
  CONFIRM_STEP = "CONFIRM_STEP",
  UNCONFIRM_STEP = "UNCONFIRM_STEP",
  CONFIRM_CARGO_PICKUP_DETAILS = "CONFIRM_CARGO_PICKUP_DETAILS",
  CONFIRM_FREIGHT_INSTRUCTIONS = "CONFIRM_FREIGHT_INSTRUCTIONS",
  CONFIRM_CARGO_PALLET_DETAILS = "CONFIRM_CARGO_PALLET_DETAILS",
  CONFIRM_SHIPPING_QUOTE = "CONFIRM_SHIPPING_QUOTE",
  CONFIRM_SHIPMENT_REVIEW = "CONFIRM_SHIPMENT_REVIEW",
}
